import Vue, { ComponentOptions } from 'vue'
import Filters from './filters/filters.vue'
import List from './list/list.vue'
import Chat from './chat/chat.vue'

export default {
  components: {
    Filters,
    List,
    Chat,
  },
} as ComponentOptions<Vue> & Export

type Export = { exportComponents?: any }
